// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wG8rw","text":"styles_text__JDKX5","icon":"styles_icon__68cLy","iconHeart":"styles_iconHeart__z2bwa","a-pulse":"styles_a-pulse__Iaq3h"};